<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style scoped>
/deep/.floatbox {
  display: flex;
  position: fixed;
  bottom:20px;
  padding: 10px;
  background: url("~@/assets/button-style.png") 8px 10px no-repeat #66C779;
  background-size: 11px 15px;
  border-radius: 25px;
  width:94%;
  align-items: center;
  justify-content: center;
  height:52px;
  border: none;
  left:3%;
  right:3%;
  font-size:18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
}
/deep/.jg-list{
  background: #ffffff;
  padding: 0 10px;
}
/deep/.jg-box{
  min-height:162px;
  background: #F4F5F7;
  border-radius:12px;
  margin-bottom: 10px;
  padding-bottom: 10px;
}
/deep/.jg-list-top{
  display: flex;
  padding: 10px;
}
/deep/.jg-list-top img{
  display: flex;
  width:115px;
  height:90px;
  background: #ECECEC;
  border-radius:12px;
  margin-right: 8px;
}
/deep/.jg-right{
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
  padding: 3px 0;
}
/deep/.jg-right h2{
  display: flex;
  height:16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp:1;
  -webkit-box-orient: vertical;
  /*flex-wrap: nowrap;*/
  margin-bottom:10px;
}
/deep/.jg-right h2 a{
  font-size:16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}
/deep/.jg-right span{
  display: flex;
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #A1A1A1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-bottom: 10px;
  position: relative;
  width: 100%;
  justify-content: space-between;
 }
/deep/.jg-right span.time{
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #A1A1A1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp:1;
  -webkit-box-orient: vertical;
  height: 12px;
}
/deep/.jg-right span:last-child{
  margin-bottom: 0;
}
/deep/.jg-bottom{
  display: flex;
  border-top: 1px solid #dedede;
  padding:10px 10px 0 10px;
  align-items: center;
  justify-content: space-between;
}
/deep/.jg-but {
  display: flex;
  padding:0 3px;
  background: url("~@/assets/button-style.png") 3px 3px no-repeat #66C779;
  background-size: 11px 15px;
  border-radius: 25px;
  width:114px;
  height:32px;
  align-items: center;
  justify-content: center;
  border: none;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
}
/deep/.jg-bottom b{
  font-size:18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FF9900;
}
/deep/.jg-bottom  i{
  font-size:12px;
}
/deep/.van-button__content span{
  font-weight: bold;
}
/deep/.van-nav-bar{
  background:#66C779;
}
/deep/.van-nav-bar__title{
  font-size:16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
}
/deep/.van-nav-bar .van-icon{
  color: #ffffff;
}
/deep/.van-nav-bar label{
  color: #fff;
  background:none;
  border:none;
}
/deep/.van-nav-bar__text{
  color: #ffffff;
}
/deep/.van-tabbar-item--active{
  font-size:12px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #66C779 ;
  display: -webkit-box;
}

</style>
